var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'alert' + _vm.alertClass() + (_vm.isOpen ? ' open' : '')},[_c('div',{staticClass:"alert__txt"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('span',{staticClass:"alert__close",on:{"click":_vm.closeAlert}})])
}
var staticRenderFns = []

export { render, staticRenderFns }